import React from "react";
import Card from "components/card";
import { 
    LuTrophy, LuRocket,
} from "react-icons/lu"
import RewardCard from "./RewardCard";

const MyAwards = () => {
    return (
        <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200 dark:border-purple-900/50">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                <h4 className="leading-none flex items-center gap-2">
                    <LuTrophy className="w-5 h-5 text-amber-600" />
                    My Awards
                </h4>
                <p className="text-slate-700">
                    Your achievements and recognition badges
                </p>
            </div>
            <div className="px-6 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <RewardCard
                        title="Innovation Award"
                        date="Sept 2025"
                        icon={LuRocket}
                        iconGradient="bg-teal"
                        popoverContent="Innovation Trailblazer"
                    />
                    <RewardCard
                        title="Peak Performer"
                        date="Aug 2025"
                        icon={LuTrophy}
                        iconGradient="yellow"
                        popoverContent="Peak Performer"
                    />
                </div>
            </div>
        </Card>
    )
};
export default MyAwards;